import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { QueryBuilderComponent } from '../query-builder/query-builder.component';
import { SocialAiReportsChartComponent } from '../../components/tables/social-ai-reports-chart/social-ai-reports-chart.component';

@Component({
  selector: 'app-social-ai-reports-tab',
  standalone: true,
  imports: [CommonModule, RouterModule, QueryBuilderComponent, SocialAiReportsChartComponent],
  templateUrl: './social-ai-reports-tab.component.html',
})
export class SocialAiReportsTabComponent {

  constructor(private router: Router) { }

viewMode = signal<'query' | 'metrics'>('query');

setView(mode: 'query' | 'metrics') {
  this.viewMode.set(mode);
}

  
}
